import { LogLevel } from "@azure/msal-browser";
import config from '../../env';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */


export const msalConfig = {
  auth: {
    clientId: config.azure_client_id,
    authority: `https://${config.azure_authority_domain}/${config.azure_domain}/${config.azure_auth_policy}`,
    redirectUri:config.azure_redirect_uri,
    knownAuthorities: [config.azure_domain, config.azure_authority_domain],
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    // storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // Set this to true for storing auth state in a cookie
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};
